import { StopOutlined } from "@ant-design/icons";
import { clsx } from "clsx";
import moment from "moment";

import { shortTimezoneMapping, Zone } from "@regal-voice/ui";
import { BlockContainer } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContainer/BlockContainer";
import { BlockContent } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContent/BlockContent";
import { BlockTitle } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockTitle/BlockTitle";
import sharedStyles from "Components/elements/RVFlow/Shared/FlowNodeBlocks/FlowNodeBlocks.module.scss";
import {
    formatDelayDuration,
    getJourneyNodeIcon,
    getJourneyNodeTypeConfig,
} from "Components/elements/RVFlow/Shared/JourneyNodePresentation";
import { NodeUserCount } from "Pages/orchestration/Pages/journeys/JourneyEditPage/Components/JourneyBuilder/shared/Components/NodeUserCount/NodeUserCount";
import { NodeType } from "Types/Journey";

import styles from "./DelayBlock.module.scss";

type SkipTimeType = {
    hours: string;
    minutes: string;
};

// @TODO? Move this to or the the version in TimeServices
function formatSkipTime(skipTime: SkipTimeType): string {
    return moment(
        `${skipTime?.hours || 0}`.padStart(2, "0") + `${skipTime?.minutes || 0}`.padStart(2, "0"),
        "HHmm"
    ).format("hh:mma");
}
// @TODO? Move this to or the the version in TimeServices
function formatDaysOfWeek(selectedDays: number[]): string {
    const dayMap = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    return selectedDays.map((item) => dayMap[item]).join(", ");
}
// @TODO? Move this to or the the version in TimeServices
function formatTimezone(timezone: string): string {
    if (timezone === "CONTACT_TIMEZONE") {
        return "Local";
    }

    return shortTimezoneMapping[timezone as Zone];
}

// TODO: update type to import type { SharedBlockProps } from "Components/elements/RVFlow/RVFlowTypes";
// and follow up updateContactBlock or the IVR blocks work

const BLOCK_VARIANT = getJourneyNodeTypeConfig(NodeType.Delay).variant;
const BLOCK_ICON = getJourneyNodeIcon(NodeType.Delay);

export function DelayBlock({ data }: { data?: any }): JSX.Element {
    const activePropertyDelay =
        data?.delayType === "property" && (!!data?.contactAttribute || !!data?.delayPropertyName);
    const isActive = data?.days || data?.hours || data?.minutes || data?.seconds || data?.empty || activePropertyDelay;

    function getSkipTime() {
        const { skipTimeOfDay, skipFromTime, skipToTime, timezone } = data || {};

        return skipTimeOfDay ? (
            <div className={clsx("flex-row align-center", styles.skipTime)}>
                <StopOutlined />
                <span>{`Skip ${formatSkipTime(skipFromTime)}-${formatSkipTime(skipToTime)} ${
                    formatTimezone(timezone) || ""
                }`}</span>
            </div>
        ) : null;
    }

    function getSkipDays() {
        const { skipDaysOfWeek, selectedWeekDays } = data || { skipDaysOfWeek: false, selectedWeekDays: [] };

        return skipDaysOfWeek && selectedWeekDays ? (
            <div className={clsx("flex-row align-center", styles.skipTime)}>
                <StopOutlined />
                <span>{`Skip ${formatDaysOfWeek(selectedWeekDays || [])}`}</span>
            </div>
        ) : null;
    }

    return (
        <BlockContainer variant={BLOCK_VARIANT} icon={BLOCK_ICON}>
            <BlockTitle nodeData={data} fallBackDisplay={"Timing"}></BlockTitle>
            <BlockContent isActive={isActive}>
                <div className={sharedStyles.breakText}>{formatDelayDuration(data)}</div>
                {getSkipTime()}
                {getSkipDays()}
                <NodeUserCount nodeData={data} display={isActive} className={styles.nodeMetricsContainer} />
            </BlockContent>
        </BlockContainer>
    );
}
